import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { Router, Route, Link, browserHistory } from 'react-router'
import AppStore from '../../stores/AppStore'
import TemplateData, { localsMessages, isMobileHeaderExp } from '../../utility/getTemplateData'
import PostTransaction from '../confirmation/postTransaction'
import * as FPT from '../../utility/fpt'
import HurricaneHarveyCard from '../../components/HurricaneHarveyCard';
import { shouldShowHurricaneHarveyPromotion } from '../../utility/helper.js';
import _isFunction from 'lodash/isFunction';
import { hideLanguageSelector } from '../../utility/languageSelector';

const messages = localsMessages('confirmation/confirmation')
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();

const STYLES = {
	confirmationSignUpStatus: {
		marginTop: '20px'
	},
	confirmationSignUpP1: {
		margin: '0px auto 10px',
		fontWeight: 'normal',
		fontSize: '24px',
		fontFamily: 'pp-sans-big-regular',
	},
	confirmationSignUpP2: {
		margin: '10px auto 0px',
		fontSize: '15px',
		maxWidth: '345px',
		fontFamily: 'pp-sans-big-regular'
	}
}

class GuestSignUp extends React.Component {
    render() {
		return (
			<div>
				{this.props.signUpStatus ?
					<div className={`donate_wrapper ${isMobileHeaderExp() ? 'mobile_view' : ''}`} style={{ ...STYLES.confirmationSignUpStatus }}>
						<div className="row confirmation_sign_up_success">
							<div className="col-xs-12 col-sm-12 col-md-12">
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP1 }}>
									{this.props.successMessage1}
								</p>
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP2 }}>
									{this.props.successMessage2}
								</p>
							</div>
						</div>
					</div>
				:
					<div className={`donate_wrapper ${isMobileHeaderExp() ? 'mobile_view' : ''}`} style={{ ...STYLES.confirmationSignUpStatus }}>
						<div className="row confirmation_sign_up_success">
							<div className="col-xs-12 col-sm-12 col-md-12">
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP1 }}>
									{this.props.failMessage1}
								</p>
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP2 }}>
									{this.props.failMessage2}
								</p>
							</div>
						</div>
					</div>
				}
			</div>
		);
	}
}


export default class extends React.Component {
    static propTypes = {
		label: PropTypes.string
	};

    constructor(props) {
        super(props);

        let confirmationData = AppStore.getConfirmation() || {}

        this.state = {
			amount: confirmationData.amount || '',
			confirmationNumber: confirmationData.confirmationNumber || '',
			postBackData: confirmationData || {},
			displayMyAccount: confirmationData.showAccountOverview || false,
			orgName : (TemplateData.donationName) ? TemplateData.donationName : '',

			autoRedirect : TemplateData.returnAutoRedirect !== '',
			autoRedirectUrl : (TemplateData.charityReturnUrl) ? TemplateData.charityReturnUrl : '',
			autoRedirectMethod: (TemplateData.returnMethod) ? TemplateData.returnMethod : '',
			syncReturnUrl: confirmationData.syncReturnUrl || '',

			isSignUp: confirmationData.isSignUp || false,
			signUpStatus: confirmationData.signUpSuccess || false
		};
    }

    componentDidMount() {
		this.isComponentMounted = true;
		hideLanguageSelector();

		this.serverRequest = $.post('/donate/guest/postTransaction', {}).then((response) => {
			$('.spinneroverlay').hide();
			if(response.data.confirmationData){
				if (this.isComponentMounted) { // Dont call setState on an unmounted component
					this.setState({
						amount: response.data.confirmationData.amount || AppStore.getDonationAmount(),
						guestSignUp: response.data.confirmationData.guestSignUp || false ,
						displayMyAccount: response.data.confirmationData.showAccountOverview || false
					})
				}
			}
		});

		let confData = AppStore.getConfirmation() || {}
		let isSignUp = confData.showAccountOverview || false;
		let trid = confData.confirmationNumber || '';

		if (TemplateData.fptPageName === 'guestULSignUp' || isSignUp) {
			FPT.trackPage('main:donate:wps:signup:success', 'main:donate:wps:signup:success:web::', 'trid', trid)
		} else {
			FPT.trackPage('main:donate:wps:guest:success', 'main:donate:wps:guest:success:web::', 'trid', trid)
		}
	}

    componentWillUnmount() {
		this.isComponentMounted = false;
		if (this.serverRequest && _isFunction(this.serverRequest.abort)) {
			this.serverRequest.abort()
		}
		
	}

    handleMyAccount = () => {
		FPT.trackLinkClick('myAccount');
		window.location.href = '/myaccount'
	};

    handleAuthRedirectFail = () => {

		let finalUrl = this.state.autoRedirectUrl

		if (this.state.syncReturnUrl) {
			finalUrl = this.state.syncReturnUrl
		}

		if (finalUrl.indexOf('http') != 0 && finalUrl.indexOf('//') != 0) {
		    finalUrl = '//' + finalUrl;
		}

		window.location.href = finalUrl
	};

    renderHurricaneHarveyCard = () => {
		if (shouldShowHurricaneHarveyPromotion()) {
			return <HurricaneHarveyCard pageName="guest"/>
		}
		return null;
	};

    render() {

		const { label = {}} = messages || {}
		const { successMessage1, successMessage2, failMessage1, failMessage2 } = label
		const signUpStatus = this.state.signUpStatus
		let yourdonation = label.yourdonation
		let returnText = label.returnText
		let returnto = label.returnto
		let myAccount = label.myAccount

		yourdonation = yourdonation && yourdonation.replace('{amount}', this.state.amount)
		yourdonation = yourdonation && yourdonation.replace('{orgName}', this.state.orgName)
		returnText = returnText && returnText.replace('{orgName}', this.state.orgName)

		returnto = returnto && returnto.replace('{orgName}', this.state.orgName)

		const guestSignUpProps = {
			signUpStatus, successMessage1, successMessage2, failMessage1, failMessage2,
		}

		let rp_status =  AppStore.getDonationRecurring() === 'checked'
		let yourRPdonation = label.yourRPdonation
		yourRPdonation = yourRPdonation && yourRPdonation.replace('{amount}', this.state.amount)
		yourRPdonation = yourRPdonation && yourRPdonation.replace('{orgName}', this.state.orgName)

		let giftaidFlag = AppStore.getGiftaidItFlagStatus();
		let donatedAmount = AppStore.getDonationAmount();
		let extraDonateAmount = giftaidFlag ? (TemplateData.donationSymbol + ((donatedAmount * donateGiftPercentage) - donatedAmount).toFixed(2)) : '';

		let giftAidConfText = giftaidFlag ? (rp_status ? label.giftAidRecurring : label.giftAid) : '';

		return (
			<div>
				<div className={`donate_wrapper ${isMobileHeaderExp() ? 'mobile_view' : ''}`}>
					<div className="row confirmation">
						<input type="hidden" id="confirmationNumber" defaultValue={this.state.confirmationNumber} />
						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_img_holder center-block">
								<span className="icon icon-large icon-positive-large" aria-hidden="true"></span>
							</div>
						</div>

						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_header">
								{rp_status?<h4 className="text-center" dangerouslySetInnerHTML={{__html : yourRPdonation}} />:<h4 className="text-center" dangerouslySetInnerHTML={{__html : yourdonation}} />}

								{giftaidFlag &&	<div className="text-center" style={{ ...STYLES.confirmationSignUpP2 }}>
									 + {extraDonateAmount} {giftAidConfText}
									</div>
								}
							</div>
						</div>

						{this.state.autoRedirect ?
							<div>
								<div className="col-xs-12 col-sm-12 col-md-12">
									<div className="confirmation_reciept_wrapper">
										<h6 className="text-center">{returnText}</h6>
									</div>
									<div className="text-center">
										<a onClick={this.handleAuthRedirectFail} className="pp_guest_btn">{returnto}</a>
									</div>
								</div>
								<PostTransaction
									orgName={this.state.orgName}
									postdata={this.state.postBackData}
									syncReturnUrl={this.state.syncReturnUrl}
									method={this.state.autoRedirectMethod}
									action={this.state.autoRedirectUrl}/>
							</div> : null
						}
						{this.state.guestSignUp ? <div></div> : null}
						{(this.state.displayMyAccount && !this.state.autoRedirect) ?
							<div className="col-xs-12 col-sm-12 col-md-12 text-center">
								<div className="pp_guest_btn_wrapper">
									<a onClick={this.handleMyAccount} className="btn btn-primary pp_guest_btn">{myAccount}</a>
								</div>
							</div>: null}
					</div>
				</div>

				{ this.state.isSignUp ? <GuestSignUp { ...guestSignUpProps } /> : null }

				{this.renderHurricaneHarveyCard()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./pages/guest/confirmation.js